import { render, staticRenderFns } from "./MlbBrowseTeam.vue?vue&type=template&id=13d41865&scoped=true"
import script from "./MlbBrowseTeam.vue?vue&type=script&lang=js"
export * from "./MlbBrowseTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d41865",
  null
  
)

export default component.exports